import { Dialog, DialogContent } from '@dfh-corp-sites/ui'
import { useLocation } from '@reach/router'
import { navigate } from 'gatsby'
import React, { useState } from 'react'

import useMediaQuery from '../../../hooks/useMediaQuery'
import { useUserAccessPolicy } from '../../../lib/auth/user-access-policy'
import { resourceCategoryUrlMapping, resourceTypeUrlMapping } from '../../../utils/libraryTools'
import ResourceFiltersLink from './ResourceFiltersLink'

import clearIcon from '../../../img/close_modal.svg'
import closeIcon from '../../../img/icons/-.svg'
import openIcon from '../../../img/icons/+.svg'
import filters from '../../../img/icons/filters.svg'

const transitionClasses = 'absolute inset-0 w-4 h-4 transition-opacity duration-200 ease-in-out'

const ResourceFilters = ({ className, searchOptions, libraryType, meta }) => {
  const { canReadPharmacyContent } = useUserAccessPolicy()
  const [isFiltersOpen, setIsFiltersOpen] = useState(true)
  const [isCategoryOpen, setIsCategoryOpen] = useState(false)
  const location = useLocation()

  const { count } = meta

  const filterLinkActive = searchOptions.libraryResourceFilters[0].category

  const [isActive, setIsActive] = useState(false)
  const isWide = useMediaQuery({ minWidth: '768px' })

  const handleClearAll = () => {
    const params = new URLSearchParams(location.search)
    params.delete('type')
    navigate(`${location.pathname}?${params.toString()}`)
  }

  const getFilters = () => {
    return Object.entries(resourceCategoryUrlMapping)
      .filter(([type]) => {
        if (type === 'pharmacy-content') return false

        if (libraryType === 'public') {
          return ['casi-session', 'patient-brochure', 'patient-education'].includes(type)
        }
        return true
      })
      .map(([type, name]) => ({
        type,
        name,
        countKey: resourceTypeUrlMapping[type],
      }))
  }

  const FacetedFilterList = () => (
    <ul className="px-5 xl:px-10 pt-7 md:pt-0 pb-2 border-b border-rule-grey faceted-list">
      <li>
        <ul>
          {getFilters().map((filter) => (
            <ResourceFiltersLink
              key={filter.type}
              count={count[filter.countKey]}
              type={filter.type}
              name={filter.name}
              filterLinkActive={filterLinkActive}
            />
          ))}
          {canReadPharmacyContent && libraryType === 'professional' && (
            <ResourceFiltersLink
              count={count.pharmacyContent}
              type="pharmacy-content"
              name="Pharmacy Content"
              filterLinkActive={filterLinkActive}
            />
          )}
        </ul>
      </li>
    </ul>
  )

  return (
    <>
      <div className={`${className} ${isActive ? 'drawer-open' : ''}`}>
        <div className="flex items-center justify-between md:gap-3.5 pr-2.5 md:px-5 xl:px-10 md:py-6 border-b border-rule-grey h-[45px] md:h-[62px] xl:h-[82px]">
          <div className="items-center gap-3.5 hidden md:flex">
            <img src={filters} alt="Filters icon" className="w-5 h-5" />
            Filters
          </div>
          {/* mobile view */}
          <button
            onClick={() => setIsCategoryOpen(!isCategoryOpen)}
            className={`flex items-center pl-2.5 gap-3.5 w-1/2 h-full md:hidden${isCategoryOpen ? ' bg-brand-navy-3' : ''}`}
          >
            <img src={filters} alt="Filters icon" className="w-5 h-5" />
            Filters
          </button>
          <div className="md:text-lg md:hidden border-l border-rule-grey w-1/2 h-full flex items-center justify-end">
            <span>{meta.count.all} Items</span>
          </div>
          {/* tablet only */}
          {filterLinkActive && (
            <button
              onClick={handleClearAll}
              className="hidden md:flex xl:hidden items-center gap-1.5"
            >
              <img src={clearIcon} alt="Clear filters icon" className="h-3 w-3" />
              <span>Clear</span>
            </button>
          )}
        </div>
        {/* desktop view */}
        <div className="items-center justify-between pt-7 px-5 xl:px-10 mb-5 hidden md:flex">
          <span className="font-bold">Type</span>
          <button className="relative w-4 h-4" onClick={() => setIsFiltersOpen(!isFiltersOpen)}>
            <img
              src={closeIcon}
              alt="Close filters icon"
              className={`${transitionClasses} ${isFiltersOpen ? 'opacity-100' : 'opacity-0'}`}
            />
            <img
              src={openIcon}
              alt="Open filters icon"
              className={`${transitionClasses} ${isFiltersOpen ? 'opacity-0' : 'opacity-100'}`}
            />
          </button>
        </div>
        {/* mobile view */}
        {isCategoryOpen && (
          <button
            className="flex items-center justify-between font-bold md:hidden py-[26px] px-10 w-full border-b border-rule-grey"
            onClick={() => setIsActive(!isActive)}
          >
            <span>Category</span>
            <img src={openIcon} alt="Open filters icon" />
          </button>
        )}

        {isFiltersOpen && isWide && <FacetedFilterList />}
      </div>
      <Dialog open={isActive} onOpenChange={setIsActive}>
        <DialogContent>
          <FacetedFilterList />
        </DialogContent>
      </Dialog>
    </>
  )
}

export default ResourceFilters
